import { asyncHandler } from '../async-handler';
import store from '../../../store/store';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { SHOP_PROMPT_SCHEDULES_API } from '../../constants/central-api';
import type { CreatePromptSchedulePayload, PromptSchedule } from './types';

export default async function create_prompt_schedule_api_call(
  payload: CreatePromptSchedulePayload
): Promise<{ success: boolean; message?: string; data?: PromptSchedule }> {
  const shopSlug = store.getState().user?.company?.shop_slug;
  const accessToken = store.getState().auth.authorization.accessToken;

  if (!shopSlug) {
    return { success: false, message: 'No shop selected.' };
  }

  const requestInfo: RequestInfo = {
    url: SHOP_PROMPT_SCHEDULES_API(shopSlug),
    method: 'POST',
    body: JSON.stringify(payload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: accessToken.type + ' ' + accessToken?.sellerToken,
    },
  };

  const res: any = await asyncHandler(
    requestInfo,
    'CREATE_PROMPT_SCHEDULE',
    'Prompt schedule created.',
    true
  );

  const response = res?.data;
  return response ?? { success: false };
}
